import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';

const cssPrefix = 'RunPlanDialog';

export namespace RunPlanDialogStyles {
  export const Intro = cssClass(cssPrefix, 'intro', {
    marginBottom: TabStyles.Spacing.MediumSpace,
  });

  export const Alert = cssClass(cssPrefix, 'alert', {
    marginBottom: TabStyles.Spacing.MediumSpace,
  });

  export const ItemList = cssClass(cssPrefix, 'item-list', {
    maxHeight: 320,
    overflowY: 'auto',
    border: `1px solid ${DesignTokens.color.elevation.border.default.subtle}`,
    borderRadius: 4,
  });

  export const ItemRow = cssClass(cssPrefix, 'item-row', {
    display: 'flex',
    alignItems: 'center',
    padding: `${TabStyles.Spacing.DefaultSpace}px ${TabStyles.Spacing.MediumSpace}px`,
    borderTop: `1px solid ${DesignTokens.color.elevation.border.default.subtle}`,
    $nest: {
      '&:first-child': {
        borderTop: 'none',
      },
    },
  });

  export const ItemText = cssClass(cssPrefix, 'item-text', {
    minWidth: 0,
    marginLeft: TabStyles.Spacing.DefaultSpace,
  });

  export const ItemName = cssClass(cssPrefix, 'item-name', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  });

  export const ItemDetail = cssClass(cssPrefix, 'item-detail', {
    color: DesignTokens.color.font.default.subtle,
    fontSize: TabStyles.Typography.Sizing.Default,
  });

  export const Summary = cssClass(cssPrefix, 'summary', {
    marginTop: TabStyles.Spacing.DefaultSpace,
    color: DesignTokens.color.font.default.subtle,
  });

  export const Centered = cssClass(cssPrefix, 'centered', {
    display: 'flex',
    justifyContent: 'center',
    padding: TabStyles.Spacing.ExtraLargeSpace,
  });

  export const ProgressBar = cssClass(cssPrefix, 'progress-bar', {
    width: '100%',
  });
}
